module.exports = __webpack_public_path__ + "img/title.7e4d76e8.png";